"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _dynamic = require("@mui-treasury/styles/avatar/dynamic");

var _flex = require("@mui-treasury/components/flex");

var _info = require("@mui-treasury/components/info");

var _chatz = require("@mui-treasury/styles/info/chatz");

var _customComponents = require("../../../../../../utils/customComponents");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* istanbul ignore next */
var Icon = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/atoms/Icon/Icon"));
  });
});
/* istanbul ignore next */

var ButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/ButtonRedirect/ButtonRedirect"));
  });
});
/* istanbul ignore next */

var ButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/ButtonDownload/ButtonDownload"));
  });
});
/* istanbul ignore next */

var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
});
/* istanbul ignore next */

var IconButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonDownload/IconButtonDownload"));
  });
});
/* istanbul ignore next */

var IconButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/IconButtonDialog/IconButtonDialog"));
  });
});
/* istanbul ignore next */

var ButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/ButtonDialog/ButtonDialog"));
  });
});
var components = {
  ButtonRedirect: ButtonRedirect,
  ButtonDownload: ButtonDownload,
  ButtonDialog: ButtonDialog,
  IconButtonRedirect: IconButtonRedirect,
  IconButtonDownload: IconButtonDownload,
  IconButtonDialog: IconButtonDialog
};
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    text: {
      display: 'flex',
      alignItems: 'center',
      '& > svg': {
        fontSize: 18,
        color: '#888',
        marginRight: 4
      }
    }
  };
});

var ChatzListItem = function ChatzListItem(_ref) {
  var src = _ref.src,
      title = _ref.title,
      subtitle = _ref.subtitle,
      iconButton = _ref.iconButton,
      infoText = _ref.infoText,
      infoIcon = _ref.infoIcon,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid;
  var avatarStyles = (0, _dynamic.useDynamicAvatarStyles)({
    size: 72
  });
  var styles = useStyles();
  var icontBtn = iconButton[0];
  var iconInfo = infoIcon[0];
  return /*#__PURE__*/_react.default.createElement(_flex.Column, {
    gap: 2,
    className: storyblokClass,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement(_flex.Row, {
    mt: 2,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_flex.Item, {
    position: "middle"
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    classes: avatarStyles,
    src: src
  })), /*#__PURE__*/_react.default.createElement(_info.Info, {
    useStyles: _chatz.useChatzInfoStyles,
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement(_info.InfoTitle, null, title), /*#__PURE__*/_react.default.createElement(_info.InfoSubtitle, null, subtitle), /*#__PURE__*/_react.default.createElement(_info.InfoCaption, {
    className: styles.text
  }, iconInfo && /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, (0, _customComponents.renderComponentsWithBridge)({
    Icon: Icon
  }, _objectSpread(_objectSpread({}, iconInfo), {}, {
    size: 'small'
  }))), infoText)), /*#__PURE__*/_react.default.createElement(_flex.Item, {
    position: "right"
  }, icontBtn && /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, (0, _customComponents.renderComponentsWithBridge)(components, _objectSpread(_objectSpread({}, icontBtn), {}, {
    size: 'small'
  }))))));
};

var _default = ChatzListItem;
exports.default = _default;
ChatzListItem.propTypes = {
  src: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string.isRequired,
  iconButton: _propTypes.default.arrayOf(_propTypes.default.shape()),
  infoIcon: _propTypes.default.arrayOf(_propTypes.default.shape())
};
ChatzListItem.defaultProps = {
  iconButton: [],
  infoIcon: []
};